// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action[data-v-072e0a47] {\n  padding: 2rem 1rem 1rem;\n}", ""]);
// Exports
module.exports = exports;
